import { Media } from '../presentational/media';
import Skeleton from '../presentational/skeleton';

export default function SkeletonMythicPlusLeaderboard() {
	return (
		<div>
			<Media greaterThanOrEqual="md">
				<div style={{ display: 'flex' }}>
					<Skeleton width={91} height={32} style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }} />
					<Skeleton
						width={114}
						height={32}
						style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }}
					/>
					<Skeleton
						width={118}
						height={32}
						style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }}
					/>
				</div>
			</Media>
			<Media lessThan="md">
				<div style={{ display: 'flex' }}>
					<Skeleton width={120} height={42} style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }} />
				</div>
			</Media>

			<Skeleton height={36} />
			<Skeleton variant="item" height={81} style={{ marginBottom: 24 }} animate />
		</div>
	)
}
